import {
    Button,
    useDisclosure,
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
} from "@chakra-ui/react";

const HistoryCardWithYear = (props) => {
    const deletionAlert = useDisclosure();

    return (
        <>
            <div>
                <span className="content_title" style={{ fontWeight: "600", marginTop: "50px" }}>
                    Untill {props.historyCard.year}
                </span>
                {props.historyCard.year !== new Date().getFullYear() && (
                    <Button ml={3} mb={2} onClick={deletionAlert.onOpen}>
                        기준 삭제
                    </Button>
                )}
                <div className="flex flex-col w-full h-full ml-72 mt-10">{props.historyCard.cards}</div>
                <AlertDialog isOpen={deletionAlert.isOpen} onClose={deletionAlert.onClose}>
                    <AlertDialogOverlay>
                        <AlertDialogContent>
                            <AlertDialogHeader fontSize="4xl" fontWeight="bold">
                                삭제
                            </AlertDialogHeader>

                            <AlertDialogBody fontSize="4xl">작성한 내용을 삭제하시겠습니까?</AlertDialogBody>

                            <AlertDialogFooter>
                                <Button fontSize="4xl" onClick={deletionAlert.onClose}>
                                    취소
                                </Button>
                                <Button
                                    fontSize="4xl"
                                    colorScheme="red"
                                    ml={3}
                                    onClick={() => {
                                        props.deleteStandard(Number(props.historyCard.year));
                                        deletionAlert.onClose();
                                    }}
                                >
                                    삭제
                                </Button>
                            </AlertDialogFooter>
                        </AlertDialogContent>
                    </AlertDialogOverlay>
                </AlertDialog>
            </div>
        </>
    );
};

export default HistoryCardWithYear;
